import { useReducer } from 'react'
import { useQuery } from 'react-query'
import { getCategoriesBySlug } from 'src/@shared/service/cms-api'
import { GetCategoriesParams } from 'src/@shared/service/cms-api.types'

import { BadgeItem } from '@atk/components/ui/BadgeList/BadgeList'

import { Category } from '../../../@shared/types/cms/categories'
import useBlogList from './useBlogList'

export type BlogState = {
    search?: string
    category?: string
}

const reducer = (currentState: BlogState, newState: BlogState) => {
    return { ...currentState, ...newState }
}

export default function useBlogPage(initialCatArgs: GetCategoriesParams) {
    const { data: categories } = useQuery(['categories'], () => getCategoriesBySlug(initialCatArgs))

    const categoryList = categories as Category[]

    const catList: BadgeItem[] = categoryList.map(
        (category: Category) =>
            ({
                value: category.name,
                _id: category._id,
                slug: category.meta?.slug,
            } as BadgeItem)
    )

    const initialState = {
        search: '',
        category: '',
    }
    const [{ search, category }, setState] = useReducer(reducer, initialState)

    const { blogList, isLoading, hasNextPage, fetchNextPage } = useBlogList(initialCatArgs, search, category)

    const featured = blogList[0]

    const handleBadgeListClick = (item: string) => {
        setState({
            category: categories?.find((categoryItem: Category) => categoryItem._id === item)?.meta?.slug ?? '',
        })
    }

    const handleSearchChange = (search: string) => {
        setState({ search })
    }

    return {
        search,
        catList,
        category,
        featured,
        blogList,
        isLoading,
        hasNextPage,
        fetchNextPage,
        handleBadgeListClick,
        handleSearchChange,
    }
}
